import { Modal, Table } from "antd";
import React from "react";
import { useQuery } from "react-query";
import jwtAxios from "../../../../auth/jwt-api";
import { uz } from "date-fns/locale";
import { format } from "date-fns";
import translate from "../../../../i18n/translate";

const actionTypeLabels = {
  order_created: "orderlog.order_created",
  order_edited: "orderlog.order_edited",
  order_deleted: "orderlog.order_deleted",
  type_changed: "orderlog.type_changed",
  payment_created: "orderlog.payment_created",
  payment_deleted: "orderlog.payment_deleted",
};

export default function OrderLogModal({ orderId, open, onClose }) {
  const { data, isLoading } = useQuery(
    ["order-log", orderId],
    () => jwtAxios.get(`/order-log/${orderId}`),
    { enabled: !!orderId && open }
  );

  const logs = data?.data?.data || [];
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: translate("orderlog.action"),
      dataIndex: "action",
      key: "action",
      render: (type) =>
        actionTypeLabels[type]
          ? translate(actionTypeLabels[type])
          : type,
    },
    {
      title: translate("orderlog.user"),
      dataIndex: "user",
      key: "user",
      render: (user) => user?.username
    },
    // {
    //   title: translate("orderlog.details"),
    //   dataIndex: "details",
    //   key: "details",
    //   render: (details) => {
    //     if (!details || typeof details !== "object") return "-";
    //     return (
    //       <div>
    //         {Object.entries(details).map(([key, value]) => (
    //           <div key={key}>
    //             <b>{key}:</b> {typeof value === "object" ? JSON.stringify(value) : String(value)}
    //           </div>
    //         ))}
    //       </div>
    //     );
    //   },
    // },
    {
      title: translate("orderlog.time"),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      render: (time) =>
        time
          ? format(new Date(time), "dd-MMMM yyyy HH:mm", { locale: uz })
          : "-",
    },
  ];

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      width={800}
      title={translate("orderlog.title")}
      footer={null}
    >
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={logs?.results?.rows}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        scroll={{ y: 400 }}
      />
    </Modal>
  );
}